import { render, staticRenderFns } from "./group_members_form.vue?vue&type=template&id=4ca942fa&scoped=true&"
import script from "./group_members_form.vue?vue&type=script&setup=true&lang=ts&"
export * from "./group_members_form.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./group_members_form.vue?vue&type=style&index=0&id=4ca942fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca942fa",
  null
  
)

export default component.exports